"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualLinkStyle = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ContextualLinkStyle = (function (_super) {
    __extends(ContextualLinkStyle, _super);
    function ContextualLinkStyle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var link = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("link"));
            link.color = {
                abs: color.value,
                themeIndex: color.themeIndex,
            };
            blockStyleStore.setElementStyle("link", link);
        };
        _this.handleUnderlineColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var link = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("link"));
            link.underline.color = {
                abs: color.value,
                themeIndex: color.themeIndex,
            };
            blockStyleStore.setElementStyle("link", link);
        };
        _this.handleUnderlineToggle = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var link = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("link"));
            link.underline.on = !link.underline.on;
            blockStyleStore.setElementStyle("link", link);
        };
        return _this;
    }
    ContextualLinkStyle.prototype.render = function () {
        var _a = this.props, filteredColors = _a.filteredColors, blockStyleStore = _a.blockStore.blockStyleStore;
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "style-shortcut__header" }, "Link style"),
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Link Color"),
                react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: this.handleColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(blockStyleStore.model.link.color), filteredColors), type: "content" }),
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_2.ToggleTheme.Dark, label: "Underline color", value: blockStyleStore.model.link.underline.on, onChange: this.handleUnderlineToggle }),
                blockStyleStore.getElementStyle("link").underline.on && (react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: this.handleUnderlineColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(blockStyleStore.model.link.underline.color), filteredColors), type: "content" }))))));
    };
    ContextualLinkStyle = __decorate([
        mobx_react_1.observer
    ], ContextualLinkStyle);
    return ContextualLinkStyle;
}(react_1.default.Component));
exports.ContextualLinkStyle = ContextualLinkStyle;
exports.default = (0, WithColorFilterSubscription_1.default)(ContextualLinkStyle);
